import { SlotGameType1_2_2Screen } from "../SlotGameType1_2_2Screen";
import { Scale} from "../.././MyHelpers";
import { IReadOnlyResourceManager, LoadingStage, ResourceManager } from "../../ResourceManager/ResourceManager";
// namespace SlotGames2 {
    export class IcyFresh2_2Screen extends SlotGameType1_2_2Screen {
        // public PrepareFont(resourceManager: ResourceManager) {
        //     //resourceManager.Add(new FontResource(this.basepath + "resources/huggable.ttf", "." + this.resid.ScopedResourceName("font")));
        //     resourceManager.Add(new FontResource(this.basepath + "resources/Melting Letter.ttf",  this.resid.ScopedResourceName(["font"])));
        //     resourceManager.Add(new FontResource(this.basepath + "resources/Melting Letter.ttf", this.resid.ScopedResourceName(["BigSymbolFreegames2-font"])));
        // }

        public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
           await super.ResourcesLoaded(loadingStage, resourceManager);

            if (loadingStage != LoadingStage.Games) {
                return;
            }
            this.title.style.width = Scale.Wpx(897);
            this.title.style.height = Scale.Wpx(637);
            this.title.style.left = Scale.Wpx(87);
            this.title.style.backgroundSize = "contain";
    }

    }
// }